<template>
    <div>
        <div class="mb-2">
            <label class="form-label small">Dimensione (cm)</label>
            <input class="form-control form-control-sm" type="number" step="0.01" min="0" v-model.number="tempSize" />
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { pxToCm, cmToPx } from '@/utils/units';

@Options({})
export default class QrCodeComponentEditor extends Vue {
    @Prop() item: OM.QrCodeComponent;

    localTempSize: number = null;

    @Watch('item')
    onItemChange() {
        this.localTempSize = null;
    }

    get tempSize() {
        return this.localTempSize ?? pxToCm(this.item.size);
    }
    set tempSize(value: number) {
        this.localTempSize = value;
        this.item.size = cmToPx(value);
    }
}
</script>
